import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

// Define initial state
const initialState = {
  customers: [],
  loading: false,
  error: null,
};

// Create async thunk for fetching all customers
export const fetchCustomers = createAsyncThunk(
  'customers/fetchCustomers',
  async (id) => {
    const response = await axios.get(`${API_URL}/customers/${id}`);
    return response.data.data;
  }
);

// Create async thunk for creating a customer
export const createCustomer = createAsyncThunk(
  'customers/createCustomer',
  async ({id, customerData}) => {
    const response = await axios.post(`${API_URL}/customers/${id}`, customerData);
    return response.data.data;
  }
);

// Create async thunk for updating a customer
export const updateCustomer = createAsyncThunk(
  'customers/updateCustomer',
  async ({ id, customerData }) => {
    const response = await axios.put(`${API_URL}/customers/${id}`, customerData);
    return response.data.data;
  }
);

// Create async thunk for deleting a customer
export const deleteCustomer = createAsyncThunk(
  'customers/deleteCustomer',
  async (id) => {
    await axios.delete(`${API_URL}/customers/${id}`);
    return id;
  }
);

// Create slice
const customerSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.customers = action.payload;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createCustomer.fulfilled, (state, action) => {
        state.customers.push(action.payload);
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        const index = state.customers.findIndex(
          (customer) => customer.id === action.payload.id
        );
        if (index !== -1) {
          state.customers[index] = action.payload;
        }
      })
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        state.customers = state.customers.filter(
          (customer) => customer.id !== action.payload
        );
      });
  },
});

// Export actions and reducer
export default customerSlice.reducer;
